import { createFileRoute, useLocation } from "@tanstack/react-router";
import { QRCodeSVG } from "qrcode.react";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { getGuestList, getGuestListId } from "../lib/api";
import {
	Groups as GroupsIcon,
	Favorite as HeartIcon,
	CameraAlt as CameraIcon,
	WineBar as CampaignIcon,
	SoupKitchen as RestaurantIcon,
	Restaurant as LunchIcon,
	Cake as CakeIcon,
	MusicNote as MusicNoteIcon,
	Extension as GamesIcon,
	LocalFireDepartment as FireIcon,
	Nightlife as CelebrationIcon,
} from "@mui/icons-material";

// Konfigurace pro dary - lze snadno upravit
const GIFT_CONFIG = {
	accountNumber: "1028290737/5500",
	variableSymbol: "20250802",
	message: "Svatba",
};

export const Route = createFileRoute("/")({
	component: RouteComponent,
});

function RouteComponent() {
	const location = useLocation();
	const [message, setMessage] = useState(GIFT_CONFIG.message);

	const refreshGuestList = useCallback(() => {
		const params = new URLSearchParams(location.search);
		const personId = params.get("person_id");
		personId &&
			getGuestListId(personId).then((data) => {
				if (data?.name) {
					setMessage(`${data.name}`);
				}
			});
	}, [location.search]);

	useEffect(() => {
		refreshGuestList();
	}, [refreshGuestList]);
	const paymentQR = `SPD*1.0*ACC:CZ5855000000001028290737*CC:CZK*MSG:Svatba*X-VS:20250802`;

	return (
		<div className="min-h-screen bg-gradient-to-b from-[#E8F5E8] via-white to-[#F5F0E6]">
			{/* Hero sekce s pozadím */}
			<div className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
				<div className="absolute inset-0 bg-[url('/images/hero-bg.jpg')] bg-cover bg-center opacity-25 transition-opacity duration-1000" />
				<div className="relative container mx-auto px-4 py-12 md:py-20 text-center">
					<div className="flex items-center justify-center mb-12">
						<h2 className="text-6xl md:text-8xl font-serif text-black mx-8 font-light italic ballet-font">
							Budeme se brát
						</h2>
					</div>
					<h1 className="text-5xl md:text-8xl font-serif text-[#7D9F7D] mb-6 md:mb-8 tracking-tight animate-fade-in">
						Kateřina Jírová & Jan Hanč
					</h1>
					<p className="text-2xl md:text-4xl text-gray-700 mb-4 md:mb-4 font-light animate-fade-in-delay">
						Srdečně vás zveme na naši svatbu
					</p>
					<div className="flex justify-center">
						<img
							src="/images/rings.png"
							alt="Propletené prstýnky"
							className="w-16 h-16 md:w-24 md:h-24 opacity-80 object-contain bg-transparent"
						/>
					</div>
					<div className="text-xl md:text-2xl text-gray-700 mb-10 md:mb-14 space-y-3 animate-fade-in-delay-2">
						<p className="font-serif">2. srpna 2025</p>
						<p className="font-serif">14:00 hodin</p>
					</div>
					<div className="flex flex-col md:flex-row justify-center gap-6">
						<a
							href="/rsvp"
							className="bg-[#7D9F7D] text-white px-8 md:px-10 py-4 md:py-5 rounded-full hover:bg-[#6A8A6A] transition-all duration-300 text-lg md:text-xl font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 animate-fade-in-delay-3"
						>
							Potvrdit účast
						</a>
					</div>
				</div>
			</div>

			{/* Místo konání */}
			<div className="bg-white py-16 md:py-32 transition-all duration-500">
				<div className="container mx-auto px-4">
					<div className="max-w-4xl mx-auto">
						<h2 className="text-4xl md:text-5xl font-serif text-[#7D9F7D] mb-12 md:mb-16 text-center">
							Místo konání
						</h2>
						<div className="bg-[#F5F0E6] rounded-3xl p-6 md:p-10 shadow-xl hover:shadow-2xl transition-all duration-300">
							<div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
								<div>
									<h3 className="text-3xl md:text-4xl font-serif text-[#7D9F7D] mb-6">
										Resort Dymník
									</h3>
									<p className="text-lg md:text-xl text-gray-700 mb-6 md:mb-8">
										Výletní 775
										<br />
										408 01 Rumburk
									</p>
									<div className="space-y-3 text-gray-600">
										<p>Email: recepce@dymnik.cz</p>
										<p>Tel: +420 773 333 242</p>
									</div>
								</div>
								<div className="space-y-6">
									<a
										href="https://dymnik.cz"
										target="_blank"
										rel="noopener noreferrer"
										className="block w-full bg-[#7D9F7D] text-white px-6 md:px-8 py-4 md:py-5 rounded-xl hover:bg-[#6A8A6A] transition-all duration-300 text-center font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1"
									>
										Navštívit web
									</a>
									<a
										href="https://maps.app.goo.gl/gLCcoW22U1J9Tx8X8"
										target="_blank"
										rel="noopener noreferrer"
										className="block w-full bg-white text-[#7D9F7D] px-6 md:px-8 py-4 md:py-5 rounded-xl hover:bg-[#F5F0E6] transition-all duration-300 text-center font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 border-2 border-[#7D9F7D]"
									>
										Navigovat na Google Maps
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Harmonogram */}
			<div className="container mx-auto px-4 py-8 md:py-16">
				<div className="max-w-4xl mx-auto">
					<h2 className="text-4xl md:text-5xl font-serif text-[#7D9F7D] mb-12 md:mb-16 text-center">
						Harmonogram
					</h2>
					<div className="bg-white rounded-lg shadow-md p-4 md:p-6">
						<div className="space-y-6 md:space-y-8">
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<GroupsIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Příjezd svatebčanů{" "}
										<span className="text-[#7D9F7D] font-medium">
											13:30
										</span>
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<HeartIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Obřad{" "}
										<span className="text-[#7D9F7D] font-medium">14:00</span>
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<CameraIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Společné focení
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<CampaignIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Přípitek a proslovy
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<RestaurantIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Polévka
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<LunchIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Odpolední raut
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<CakeIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Krájení dortu
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<MusicNoteIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										První tanec novomanželů
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<GamesIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Hudba, svatební hry
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<FireIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Prskavkový tanec
									</h3>
								</div>
							</div>
							<div className="flex items-start pl-4 relative">
								<div className="absolute left-0 top-2">
									<CelebrationIcon className="w-5 h-5 text-[#7D9F7D]" />
								</div>
								<div className="pl-8">
									<h3 className="text-lg md:text-xl font-medium text-gray-800">
										Hudba, tanec, zábava
									</h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Ubytování */}
			<div className="container mx-auto px-4 py-8 md:py-16">
				<div className="max-w-4xl mx-auto">
					<h2 className="text-4xl md:text-5xl font-serif text-[#7D9F7D] mb-12 md:mb-16 text-center">
						Ubytování
					</h2>
					<div className="grid md:grid-cols-2 gap-4 md:gap-6">
						<div className="bg-white rounded-lg shadow-md p-4 md:p-6">
							<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-3 md:mb-4">
								Kempování
							</h3>
							<p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">
								V areálu je možné přespávat ve vlastním stanu zdarma. Prosíme o
								nahlášení.
							</p>
						</div>
						<div className="bg-white rounded-lg shadow-md p-4 md:p-6">
							<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-3 md:mb-4">
								Resort Dymník
							</h3>
							<p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">
								Možnost ubytování v rezortu (ceny dle dostupnosti na webu).
							</p>
							<p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">
								Přes webové stránky je nutné rezervovat minimálně 2 noci. Pokud
								byste měli zájem pouze o jednu noc, kontaktujte nás a pokusíme
								se to zařídit.
							</p>
							<a
								href="mailto:recepce@dymnik.cz"
								className="text-[#7D9F7D] hover:text-[#6A8A6A] block mb-2 text-sm md:text-base"
							>
								recepce@dymnik.cz
							</a>
							<a
								href="tel:+420773333242"
								className="text-[#7D9F7D] hover:text-[#6A8A6A] text-sm md:text-base"
							>
								+420 773 333 242
							</a>
						</div>
						<div className="bg-white rounded-lg shadow-md p-4 md:p-6">
							<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-3 md:mb-4">
								Hotel SportLife
							</h3>
							<p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4">
								Vzdálenost cca 1,5 km od místa konání. Nutná rezervace přes
								jejich webové stránky.
							</p>
							<a
								href="https://www.sportlifehotel.cz/"
								target="_blank"
								rel="noopener noreferrer"
								className="text-[#7D9F7D] hover:text-[#6A8A6A] block mb-2 text-sm md:text-base"
							>
								https://www.sportlifehotel.cz/
							</a>
							<a
								href="tel:+420739209649"
								className="text-[#7D9F7D] hover:text-[#6A8A6A] text-sm md:text-base"
							>
								+420 739 209 649
							</a>
						</div>
					</div>
					<p className="text-gray-600 mt-4 text-center">
						Prosíme o včasné nahlášení způsobu ubytování pro lepší organizaci.
						Pokud bude potřeba pomoci s rezervací ubytování, kontaktujte nás co
						nejdříve.
					</p>
				</div>
			</div>

			{/* Dary */}
			<div className="container mx-auto px-4 py-16 md:py-32">
				<div className="max-w-4xl mx-auto">
					<h2 className="text-4xl md:text-5xl font-serif text-[#7D9F7D] mb-12 md:mb-16 text-center">
						Dary
					</h2>
					<div className="bg-white rounded-3xl shadow-xl p-6 md:p-10 hover:shadow-2xl transition-all duration-300">
						<p className="text-lg md:text-xl text-gray-700 mb-8 md:mb-10">
							Vaše přítomnost je pro nás tím největším darem. Pokud byste nám
							přesto chtěli udělat radost, budeme vděční za finanční dar, který
							využijeme na naši vysněnou svatební cestu do Afriky. Prosíme,
							zdržte se darování věcných darů.
						</p>
						<div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
							<div className="bg-[#F5F0E6] p-6 md:p-8 rounded-2xl">
								<p className="text-lg md:text-xl text-gray-700 mb-8 md:mb-10">
									Pokud nás budete chtít obdarovat online, můžete použít tyto
									údaje k našemu svatebnímu účtu:
								</p>
								<div className="space-y-4 text-gray-700 text-lg">
									<p>Číslo účtu: {GIFT_CONFIG.accountNumber}</p>
									<p>VS: {GIFT_CONFIG.variableSymbol}</p>
									<p>Zpráva pro příjemce: {message}</p>
								</div>
							</div>
							<div className="flex flex-col items-center">
								<div className="bg-white p-6 rounded-2xl shadow-lg mb-6 hover:shadow-xl transition-all duration-300">
									<QRCodeSVG
										value={paymentQR}
										size={200}
										level="M"
										marginSize={1}
									/>
								</div>
								<p className="text-sm md:text-base text-gray-600 text-center">
									Naskenujte QR kód vaší bankou
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Často kladené otázky */}
			<div className="bg-white py-12 md:py-24">
				<div className="container mx-auto px-4">
					<div className="max-w-4xl mx-auto">
						<h2 className="text-4xl md:text-5xl font-serif text-[#7D9F7D] mb-12 md:mb-16 text-center">
							Často kladené otázky
						</h2>
						<div className="bg-white rounded-lg shadow-md p-4 md:p-6">
							<div className="space-y-6 md:space-y-8">
								<div>
									<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
										Do kdy se mám přihlásit?
									</h3>
									<p className="text-sm md:text-base text-gray-600">
										<b>Prosíme o potvrzení účasti co nejdříve</b>, ale
										nejpozději do 2. července 2025. To nám pomůže lépe
										naplánovat celý den.
									</p>
								</div>

								<div>
									<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
										Jaký je dress code?
									</h3>
									<p className="text-sm md:text-base text-gray-600">
										Volba oblečení je na vašem uvážení. Budeme rádi, když se
										budete cítit pohodlně a slavnostně. Svatba bude laděná do
										světlých pastelových barev, dřeva a lučního kvítí. Pro pány
										doporučujeme oblek (zejména na obřad), nebo společenské kalhoty s košilí. Pro
										dámy společenské šaty, nebo kostýmek, ale vyhněte se prosím
										bílé a černé barvě. Volba šatů je na vás, jen
										prosíme o dodržení svatebních barev:
									</p>
									<div className="mt-4 grid grid-cols-4 gap-4">
										<div className="text-center">
											<div className="w-full h-16 rounded-lg bg-[#7D9F7D] mb-2" />
											<p className="text-sm text-gray-600">Sage zelená</p>
										</div>
										<div className="text-center">
											<div className="w-full h-16 rounded-lg bg-[#F5F0E6] mb-2" />
											<p className="text-sm text-gray-600">Přírodní béžová</p>
										</div>
										<div className="text-center">
											<div className="w-full h-16 rounded-lg bg-[#E8F5E8] mb-2" />
											<p className="text-sm text-gray-600">Světlá zelená</p>
										</div>
										<div className="text-center">
											<div className="w-full h-16 rounded-lg bg-[#FFE4C4] mb-2" />
											<p className="text-sm text-gray-600">Světlá meruňková</p>
										</div>
									</div>
								</div>

								<div>
									<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
										Mám vzít s sebou děti?
									</h3>
									<p className="text-sm md:text-base text-gray-600">
										Rádi bychom si tento významný den užili v kruhu dospělých
										přátel a rodiny. Zvažte prosím, zda nenechat své nejmenší u
										babiček, tetiček, či kamarádů, aby si i oni mohli užít
										nádherný den. Přáli bychom si, abyste si mohli plně
										vychutnat svatební oslavu a večerní zábavu bez starostí o
										nejmenší.
									</p>
								</div>

								<div>
									<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
										Je možné přenocovat přímo na místě?
									</h3>
									<p className="text-sm md:text-base text-gray-600">
										Ano, máte možnost přespání ve vlastním stanu zdarma, využít
										ubytování v Resortu Dymník nebo v Hotelu SportLife (1,5 km
										od místa konání). Více informací najdete v sekci Ubytování.
									</p>
								</div>

								<div>
									<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
										Kde mohu zaparkovat?
									</h3>
									<p className="text-sm md:text-base text-gray-600">
										Parkování je možné přímo v areálu Resortu Dymník zdarma.
									</p>
								</div>

								<div>
									<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
										Mohu fotit během svatby?
									</h3>
									<p className="text-sm md:text-base text-gray-600">
										Během svatebního obřadu je focení zakázáno, rádi bychom si
										pamatovali vaše obličeje, ne foťáky a telefony před nimi.
										Prosíme také o vypnutí všech zvuků na mobilních zařízeních.
										Po obřadu budeme rádi, když budete fotit, natáčet a sdílet
										vaše fotky ze svatebního dne do naší galerie, která je
										dostupná na těchto webových stránkách.
									</p>
								</div>

								<div>
									<h3 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
										Budou k dispozici vegetariánské/veganské varianty jídel?
									</h3>
									<p className="text-sm md:text-base text-gray-600">
										Ano, prosíme o nahlášení vašich stravovacích požadavků ve
										formuláři "Potvrzení účasti". Budeme rádi, když nám sdělíte
										i případné alergie nebo jiné stravovací omezení.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Pozvánka */}
			<div className="bg-[#F5F0E6] py-16 md:py-32">
				<div className="container mx-auto px-4 text-center">
					<p className="text-xl md:text-3xl text-gray-700 max-w-3xl mx-auto leading-relaxed font-light">
						Těšíme se na společné oslavy našeho velkého dne s vámi. Budeme rádi,
						když s námi strávíte tento výjimečný okamžik.
					</p>
				</div>
			</div>
		</div>
	);
}

// Přidání animací do globálních stylů
const styles = `
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fade-in {
  animation: fadeIn 1s ease-out forwards;
}

.animate-fade-in-delay {
  animation: fadeIn 1s ease-out 0.3s forwards;
  opacity: 0;
}

.animate-fade-in-delay-2 {
  animation: fadeIn 1s ease-out 0.6s forwards;
  opacity: 0;
}

.animate-fade-in-delay-3 {
  animation: fadeIn 1s ease-out 0.9s forwards;
  opacity: 0;
}
`;

// Přidání stylů do head
if (typeof document !== "undefined") {
	const styleSheet = document.createElement("style");
	styleSheet.textContent = styles;
	document.head.appendChild(styleSheet);
}
